import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { LoanProgramService } from '../loanprogram.service';
import { PersonaService } from '../../personas/persona.service';
import { Persona } from '../../personas/persona.model';
import { LoanProgram, AddLoanProgram, AssignmentStrategy, LoanProgramAssignmentStrategy, LoanProgramAssignmentStrategyAdd, LoanChannel } from '../loanprogram.model';


@Component({
    selector: 'app-program-add',
    templateUrl: './program-add.component.html',
    styleUrls: ['./program-add.component.css']
})
export class ProgramAddComponent implements OnInit {
    public programForm: FormGroup;
    private personas: Persona[] = [];
    public assignmentStrategiesP: AssignmentStrategy[];
    public assignmentStrategiesU: AssignmentStrategy[];
    public assignmentStrategiesC: AssignmentStrategy[];
    public assignmentStrategiesLO: AssignmentStrategy[];
    public assignmentStrategiesBC: AssignmentStrategy[];
    public assignmentStrategiesDDC: AssignmentStrategy[];
    public assignmentStrategiesCRS: AssignmentStrategy[];
    public loanChannels: LoanChannel[];
    public loanChannelValue = null;
    public isRetail = false;
    public assignmentStrategies: AssignmentStrategy[];
    public message = null;
    constructor(
        public dialogRef: MatDialogRef<ProgramAddComponent>,
        @Inject(MAT_DIALOG_DATA) public loanProgram: LoanProgram,
        private fb: FormBuilder,
        private loanProgramService: LoanProgramService,
        private personaService: PersonaService) {
        this.createForm();
    }

    ngOnInit() {        
        this.loanProgramService.getAssignmentStrategies().then(
            result => {
                this.assignmentStrategies = JSON.parse(JSON.stringify(result));
            }
        )
            .catch(error => console.log(error));
        this.personaService.getPersonas().then(result => this.personas = result)
            .catch(error => console.log(error));
        this.loanProgramService.getLoanChannels().then(
            result => {
                this.loanChannels = JSON.parse(JSON.stringify(result))
            }
        )
            .catch(error => console.log(error));
    }

    createForm() {
        this.programForm = this.fb.group({
            name: ['', Validators.required],
            closerAssignmentStrategy: [null, Validators.required],
            processorAssignmentStrategy: [null],
            underwriterAssignmentStrategy: [null, Validators.required],
            loanOpenerAssignmentStrategy: [null],
            srLoanCoordinatorAssignmentStrategy: [null],
            loanCoordinatorAssignmentStrategy: [null],
            correspondedReviewSpecialistAssignmentStrategy: [null],
            loanChannel: [null, Validators.required]
        });
    }

    prepareSaveProgram(): AddLoanProgram {        
        const formModel = this.programForm.value;
        var lpas
        if (formModel.loanChannel === 'Banked - Retail') {

            lpas = [
                new LoanProgramAssignmentStrategyAdd(formModel.closerAssignmentStrategy as string, this.personas.find(x => x.name === "Sr Closer").id),
                new LoanProgramAssignmentStrategyAdd(formModel.processorAssignmentStrategy as string, this.personas.find(x => x.name === "Processor").id),
                new LoanProgramAssignmentStrategyAdd(formModel.underwriterAssignmentStrategy as string, this.personas.find(x => x.name === "Underwriter").id),
                new LoanProgramAssignmentStrategyAdd(formModel.loanOpenerAssignmentStrategy as string, this.personas.find(x => x.name === "Loan Opener").id)
            ];
        }
        else {
            lpas = [
                new LoanProgramAssignmentStrategyAdd(formModel.closerAssignmentStrategy as string, this.personas.find(x => x.name === "Sr Closer").id),
                new LoanProgramAssignmentStrategyAdd(formModel.underwriterAssignmentStrategy as string, this.personas.find(x => x.name === "Underwriter").id),
                new LoanProgramAssignmentStrategyAdd(formModel.srLoanCoordinatorAssignmentStrategy as string, this.personas.find(x => x.name === "Sr. Loan Coordinator").id),
                new LoanProgramAssignmentStrategyAdd(formModel.loanCoordinatorAssignmentStrategy as string, this.personas.find(x => x.name === "Loan Coordinator").id),
                new LoanProgramAssignmentStrategyAdd(formModel.correspondedReviewSpecialistAssignmentStrategy as string, this.personas.find(x => x.name === "Correspondent Review Specialist").id)
            ];
        }

        const saveProgram: AddLoanProgram = {
            name: formModel.name as string,
            loanProgramAssignmentStrategies: lpas,
            loanChannelId: this.loanChannels.find(x => x.name === formModel.loanChannel).id as string
        };
        return saveProgram;
    }
    async onSubmit() {
        await this.checkDuplicateName();
        if (!this.programForm.valid)
            return;

        this.loanProgramService.addProgram(this.prepareSaveProgram())
            .then(result => this.dialogRef.close(result))
            .catch(error => console.log(error));
    }
    onChange(event) {
        this.loanChannelValue = event.value;
        this.applyToolTip(this.loanChannelValue)
        if (this.loanChannelValue === 'Banked - Retail') {
            this.isRetail = true;
            this.programForm.controls['processorAssignmentStrategy'].setValidators(Validators.required);
            this.programForm.controls['loanOpenerAssignmentStrategy'].setValidators(Validators.required);
            this.programForm.controls['srLoanCoordinatorAssignmentStrategy'].setErrors(null);
            this.programForm.controls['loanCoordinatorAssignmentStrategy'].setErrors(null);
            this.programForm.controls['correspondedReviewSpecialistAssignmentStrategy'].setErrors(null);
        }
        else if (this.loanChannelValue === 'Banked - Wholesale' || this.loanChannelValue === 'Correspondent') {
            this.isRetail = false;
            this.programForm.controls['srLoanCoordinatorAssignmentStrategy'].setValidators(Validators.required);
            this.programForm.controls['loanCoordinatorAssignmentStrategy'].setValidators(Validators.required);
            this.programForm.controls['correspondedReviewSpecialistAssignmentStrategy'].setValidators(Validators.required);
            this.programForm.controls['processorAssignmentStrategy'].setErrors(null);
            this.programForm.controls['loanOpenerAssignmentStrategy'].setErrors(null);
        }
    }
    applyToolTip(loanChannel) {
        if (loanChannel === 'Banked - Retail') {
            this.assignmentStrategiesP = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesC = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesU = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesLO = JSON.parse(JSON.stringify(this.assignmentStrategies));

            this.assignmentStrategiesP.find(x => x.description === 'RelationshipOnly').tooltip = "The loan will be assigned to the LO's Processor, if the LO doesn't have a Processor no assignment will be made.";
            this.assignmentStrategiesP.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to a Processor matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesP.find(x => x.description === 'RelationshipFirst').tooltip = "A Processor will first be selected from the LO's relationships that matched the loan program. If no matching Processor is found, the assignment is matched globally based on round robin logic.";
            this.assignmentStrategiesP.splice(this.assignmentStrategiesP.indexOf(this.assignmentStrategiesP.find(x => x.description === 'Team')), 1);
            this.assignmentStrategiesP.splice(this.assignmentStrategiesP.indexOf(this.assignmentStrategiesP.find(x => x.description === 'RegionOnly')), 1);
            this.assignmentStrategiesP.splice(this.assignmentStrategiesP.indexOf(this.assignmentStrategiesP.find(x => x.description === 'RegionFirst')), 1);

            this.assignmentStrategiesC.find(x => x.description === 'RelationshipOnly').tooltip = "The loan will be assigned to the LO's Closer, if the LO doesn't have a Closer, the loan will be assigned to their Processor's closer. If the processor doesnt have a closer, no assignment will be made.";
            this.assignmentStrategiesC.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to a Closer matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesC.find(x => x.description === 'RelationshipFirst').tooltip = "A Closer will first be selected from the LO's relationships that matched the loan program. If no matching Closer is found, the assignment is matched globally based on round robin logic.";
            this.assignmentStrategiesC.splice(this.assignmentStrategiesC.indexOf(this.assignmentStrategiesC.find(x => x.description === 'Team')), 1);

            this.assignmentStrategiesU.find(x => x.description === 'Team').tooltip = "The loan will be assigned to a UW within the LO's team based on current assignment load. The UW must also match the loan program.";
            this.assignmentStrategiesU.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to a UW based on loan program match and current assignment loan. This is global and ignores team assignments.";
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RelationshipOnly')), 1);
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RelationshipFirst')), 1);
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RegionOnly')), 1);

            this.assignmentStrategiesLO.find(x => x.description === 'RelationshipOnly').tooltip = "The loan will be assigned to the LO's Loan Opener, if the LO doesn't have a Loan Opener no assignment will be made.";
            this.assignmentStrategiesLO.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to a Loan Opener matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesLO.find(x => x.description === 'RelationshipFirst').tooltip = "A Loan Opener will first be selected from the LO's relationships that matched the loan program. If no matching Loan Opener is found, the assignment is matched globally based on round robin logic.";
            this.assignmentStrategiesLO.splice(this.assignmentStrategiesLO.indexOf(this.assignmentStrategiesLO.find(x => x.description === 'Team')), 1);
            this.assignmentStrategiesLO.splice(this.assignmentStrategiesLO.indexOf(this.assignmentStrategiesLO.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesLO.splice(this.assignmentStrategiesLO.indexOf(this.assignmentStrategiesLO.find(x => x.description === 'RegionOnly')), 1);

        }
        else {
            this.assignmentStrategiesC = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesU = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesBC = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesDDC = JSON.parse(JSON.stringify(this.assignmentStrategies));
            this.assignmentStrategiesCRS = JSON.parse(JSON.stringify(this.assignmentStrategies));

            this.assignmentStrategiesC.find(x => x.description === 'RelationshipOnly').tooltip = "Not applicable to wholesale channel loans.";
            this.assignmentStrategiesC.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to the Closer matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesC.find(x => x.description === 'RelationshipFirst').tooltip = "Not applicable to wholesale channel loans";
            this.assignmentStrategiesC.splice(this.assignmentStrategiesC.indexOf(this.assignmentStrategiesC.find(x => x.description === 'Team')), 1);
            if (loanChannel === 'Correspondent') {
                this.assignmentStrategiesC.splice(this.assignmentStrategiesC.indexOf(this.assignmentStrategiesC.find(x => x.description === 'RegionFirst')), 1);
                this.assignmentStrategiesC.splice(this.assignmentStrategiesC.indexOf(this.assignmentStrategiesC.find(x => x.description === 'RegionOnly')), 1);
            }
           
            this.assignmentStrategiesU.find(x => x.description === 'RelationshipOnly').tooltip = "Not applicable to wholesale channel loans.";
            this.assignmentStrategiesU.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to a UW based on loan program match and current assignment loan. This is global and ignores team assignments.";
            this.assignmentStrategiesU.find(x => x.description === 'RelationshipFirst').tooltip = "Not applicable to wholesale channel loans";
            this.assignmentStrategiesU.find(x => x.description === 'Team').tooltip = "The loan will be assigned to a UW within team first on current assignment load and then outside of team if applicable. The UW must also match the loan program.";
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesU.splice(this.assignmentStrategiesU.indexOf(this.assignmentStrategiesU.find(x => x.description === 'RegionOnly')), 1);

            this.assignmentStrategiesBC.find(x => x.description === 'RelationshipOnly').tooltip = "Not applicable to wholesale channel loans.";
            this.assignmentStrategiesBC.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to the Sr. Loan Coordinator matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesBC.find(x => x.description === 'RelationshipFirst').tooltip = "Not applicable to wholesale channel loans";
            this.assignmentStrategiesBC.splice(this.assignmentStrategiesBC.indexOf(this.assignmentStrategiesBC.find(x => x.description === 'Team')), 1);
            this.assignmentStrategiesBC.splice(this.assignmentStrategiesBC.indexOf(this.assignmentStrategiesBC.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesBC.splice(this.assignmentStrategiesBC.indexOf(this.assignmentStrategiesBC.find(x => x.description === 'RegionOnly')), 1);

            this.assignmentStrategiesDDC.find(x => x.description === 'RelationshipOnly').tooltip = "Not applicable to wholesale channel loans.";
            this.assignmentStrategiesDDC.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to the Loan Coordinator matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesDDC.find(x => x.description === 'RelationshipFirst').tooltip = "Not applicable to wholesale channel loans";
            this.assignmentStrategiesDDC.splice(this.assignmentStrategiesDDC.indexOf(this.assignmentStrategiesDDC.find(x => x.description === 'Team')), 1);
            this.assignmentStrategiesDDC.splice(this.assignmentStrategiesDDC.indexOf(this.assignmentStrategiesDDC.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesDDC.splice(this.assignmentStrategiesDDC.indexOf(this.assignmentStrategiesDDC.find(x => x.description === 'RegionOnly')), 1);

            this.assignmentStrategiesCRS.find(x => x.description === 'RelationshipOnly').tooltip = "Not applicable to wholesale channel loans.";
            this.assignmentStrategiesCRS.find(x => x.description === 'LoanProgram').tooltip = "The loan will be assigned to the Corresponded Review Specialist matching the loan program. The assignments are made in a round robin fashion.";
            this.assignmentStrategiesCRS.find(x => x.description === 'RelationshipFirst').tooltip = "Not applicable to wholesale channel loans";
            this.assignmentStrategiesCRS.splice(this.assignmentStrategiesCRS.indexOf(this.assignmentStrategiesCRS.find(x => x.description === 'Team')), 1);
            this.assignmentStrategiesCRS.splice(this.assignmentStrategiesCRS.indexOf(this.assignmentStrategiesCRS.find(x => x.description === 'RegionFirst')), 1);
            this.assignmentStrategiesCRS.splice(this.assignmentStrategiesCRS.indexOf(this.assignmentStrategiesCRS.find(x => x.description === 'RegionOnly')), 1);
        }
    }

    async checkDuplicateName() {
        this.message = null;
        let programName = this.programForm.value.name;
        try {
            let program = await this.loanProgramService.getLoanProgramByName(programName);
            if (program) {
                this.message = "Loan Program name already exists!"
                this.programForm.controls['name'].setErrors(Validators.required);
            }
            else {
                this.programForm.controls['name'].setErrors(null);
            }
        }
        catch (ex) {
            console.log(ex);
        }
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/loanprograms/program-add/program-add.component.ts